import React, {Component} from 'react'
import PropTypes from 'prop-types'

class DateColumn extends Component {
    render() {
        const {created} = this.props
        const timeCreate = created ? new Date(created).toLocaleString('en-GB') : '';

        return <td className="Date">
            <span className="d-flex flex-column">
                {timeCreate && <span>{timeCreate}</span>}
            </span>
        </td>
    }
}

DateColumn.propTypes = {
    created: PropTypes.string
}

export default DateColumn